export const UserManagementTableColumns = [
  // { key: 'sn', label: 'SN' },
  { key: 'action', label: 'Action' },
  { key: 'userId', label: 'User ID' },
  { key: 'designation', label: 'Initials' },
  { key: 'role', label: 'Role' },
  { key: 'status', label: 'Status' },
];
